"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("./Box"));
var Input_1 = __importDefault(require("./Input"));
var Label_1 = __importDefault(require("./Form/Label"));
var Container = (0, styled_1.default)(Box_1.default)({
    display: 'flex',
    alignItems: 'start',
    gap: '8px'
});
var StyledLabel = (0, styled_1.default)(Label_1.default)(function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return ({
        color: disabled ? theme.colors.disabledLightGrey : undefined,
        cursor: disabled ? 'not-allowed' : undefined
    });
});
var CheckboxInput = (0, styled_1.default)(Input_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        width: '20px',
        // min width/height prevents checkbox from squeezing
        minWidth: '20px',
        height: '20px',
        minHeight: '20px',
        padding: '0px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: theme.colors.placeholder,
        appearance: 'none',
        position: 'relative',
        transitionDuration: '0.2s',
        '&:hover': {
            borderColor: theme.colors.primary,
            boxShadow: "1px 1px " + theme.colors.placeholder
        },
        '&:focus': {
            borderColor: theme.colors.primary,
            boxShadow: "1px 1px " + theme.colors.placeholder
        },
        '&:disabled': {
            backgroundColor: 'initial',
            color: theme.colors.disabledLightGrey,
            cursor: 'not-allowed',
            '&:hover': {
                boxShadow: 'none',
                borderColor: theme.colors.placeholder
            }
        },
        '&:checked': {
            backgroundColor: theme.colors.primary,
            // check mark
            '&::after': {
                content: '""',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                margin: 'auto',
                marginBottom: '4px',
                position: 'absolute',
                width: 6,
                height: 12,
                borderBottom: "2px solid " + theme.colors.white,
                borderRight: "2px solid " + theme.colors.white,
                transform: 'rotate(45deg)'
            },
        }
    });
});
function Checkbox(props, ref) {
    var id = props.id, label = props.label, labelClickable = props.labelClickable, rest = __rest(props
    // when id and htmlFor are the same, clicking label will toggle checkbox
    , ["id", "label", "labelClickable"]);
    // when id and htmlFor are the same, clicking label will toggle checkbox
    var labelFor;
    if (labelClickable && typeof label === 'string') {
        labelFor = label;
    }
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(CheckboxInput, __assign({ id: labelFor || id, ref: ref }, rest, { type: "checkbox" })),
        react_1.default.createElement(StyledLabel, { htmlFor: labelFor, disabled: props.disabled }, label)));
}
exports.default = react_1.default.forwardRef(Checkbox);
